/* KVIKA FOOD — homepage motion + cart helpers. No libraries. Safe to include more than once. */
(function () {
  if (window.__kvikaInit) return;
  window.__kvikaInit = true;

  var doc = document.documentElement;
  doc.classList.add('kv-js');
  var reduceMQ = window.matchMedia('(prefers-reduced-motion: reduce)');
  var finePointer = window.matchMedia('(hover: hover) and (pointer: fine)');
  var reduce = reduceMQ.matches;

  /* ---------------- Reveal on scroll ---------------- */
  var revealIO = null;
  if (!reduce && 'IntersectionObserver' in window) {
    revealIO = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          e.target.classList.add('is-in');
          revealIO.unobserve(e.target);
        }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.12 });
  }
  function initReveal(scope) {
    var els = scope.querySelectorAll('[data-kv-reveal]:not(.is-in), .kv-draw:not(.is-in)');
    els.forEach(function (el) {
      if (revealIO) revealIO.observe(el); else el.classList.add('is-in');
    });
  }

  /* ---------------- Scroll parallax (one rAF loop, only for visible sections) ---------------- */
  var sections = new Map(); // section element -> array of {el, speed}
  var visible = new Set();
  var ticking = false;
  var sectionIO = 'IntersectionObserver' in window ? new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (e.isIntersecting) visible.add(e.target); else visible.delete(e.target);
    });
    requestTick();
  }, { rootMargin: '15% 0px 15% 0px' }) : null;

  function initParallax(scope) {
    if (reduce || !sectionIO) return;
    var roots = scope.matches && scope.matches('[data-kv-parallax]') ? [scope] : [];
    scope.querySelectorAll('[data-kv-parallax]').forEach(function (r) { roots.push(r); });
    roots.forEach(function (root) {
      var layers = [];
      root.querySelectorAll('[data-kv-speed]').forEach(function (el) {
        var s = parseFloat(el.getAttribute('data-kv-speed'));
        if (!isNaN(s) && s !== 0) layers.push({ el: el, speed: s });
      });
      if (sections.has(root)) sectionIO.unobserve(root);
      sections.set(root, layers);
      sectionIO.observe(root);
    });
  }

  function update() {
    ticking = false;
    var vh = window.innerHeight;
    var factor = window.innerWidth < 750 ? 0.45 : 1;
    visible.forEach(function (root) {
      var layers = sections.get(root);
      if (!layers || !layers.length) return;
      var r = root.getBoundingClientRect();
      var progress = (r.top + r.height / 2) - vh / 2; // 0 when section is centred
      layers.forEach(function (l) {
        var y = Math.max(-220, Math.min(220, -progress * l.speed * factor));
        l.el.style.setProperty('--kv-py', y.toFixed(1) + 'px');
      });
    });
  }
  function requestTick() {
    if (!ticking) { ticking = true; requestAnimationFrame(update); }
  }
  window.addEventListener('scroll', requestTick, { passive: true });
  window.addEventListener('resize', requestTick, { passive: true });

  /* ---------------- Gentle pointer depth (desktop, hero + combo) ---------------- */
  function initPointer(scope) {
    if (reduce || !finePointer.matches) return;
    scope.querySelectorAll('[data-kv-pointer]').forEach(function (root) {
      if (root.__kvPointer) return;
      root.__kvPointer = true;
      var raf = null, mx = 0, my = 0;
      root.addEventListener('pointermove', function (e) {
        var r = root.getBoundingClientRect();
        mx = ((e.clientX - r.left) / r.width - 0.5) * 2;
        my = ((e.clientY - r.top) / r.height - 0.5) * 2;
        if (!raf) raf = requestAnimationFrame(function () {
          raf = null;
          root.style.setProperty('--kv-mx', mx.toFixed(3));
          root.style.setProperty('--kv-my', my.toFixed(3));
        });
      });
      root.addEventListener('pointerleave', function () {
        root.style.setProperty('--kv-mx', 0);
        root.style.setProperty('--kv-my', 0);
      });
    });
  }

  /* ---------------- Variant select -> price/button ---------------- */
  document.addEventListener('change', function (e) {
    var sel = e.target.closest && e.target.closest('select[data-kv-variant]');
    if (!sel) return;
    var opt = sel.options[sel.selectedIndex];
    var card = sel.closest('.kv-card');
    if (!card || !opt) return;
    var now = card.querySelector('[data-kv-price]');
    var was = card.querySelector('[data-kv-compare]');
    var btn = card.querySelector('[data-kv-atc-btn]');
    if (now) now.textContent = opt.getAttribute('data-price');
    if (was) {
      var c = opt.getAttribute('data-compare');
      was.textContent = c || '';
      was.hidden = !c;
    }
    if (btn) {
      var ok = opt.getAttribute('data-available') === 'true';
      btn.disabled = !ok;
      btn.textContent = ok ? btn.getAttribute('data-label') : btn.getAttribute('data-soldout');
    }
  });

  /* ---------------- AJAX add to cart (falls back to normal form post without JS) ---------------- */
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var toastEl = null, toastTimer = null;
  function toast(msg, ok) {
    if (!toastEl) {
      toastEl = document.createElement('div');
      toastEl.className = 'kv-toast';
      toastEl.setAttribute('role', 'status');
      toastEl.setAttribute('aria-live', 'polite');
      document.body.appendChild(toastEl);
    }
    toastEl.classList.toggle('kv-toast--err', !ok);
    toastEl.innerHTML = '';
    var span = document.createElement('span');
    span.textContent = msg;
    toastEl.appendChild(span);
    if (ok) {
      var a = document.createElement('a');
      a.href = root + 'cart';
      a.textContent = 'View cart';
      toastEl.appendChild(a);
    }
    requestAnimationFrame(function () { toastEl.classList.add('is-on'); });
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { toastEl.classList.remove('is-on'); }, 4200);
  }

  function refreshCount() {
    fetch(root + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var sel = '[data-cart-count], .cart-count, .cart-count-bubble span[aria-hidden], #CartCount, .header__cart-count, .js-cart-count, .cart-item-count, .cart_count, .count-holder .count';
        document.querySelectorAll(sel).forEach(function (el) {
          if (el.children.length === 0) el.textContent = cart.item_count;
        });
        document.dispatchEvent(new CustomEvent('cart:refresh', { detail: cart }));
        document.dispatchEvent(new CustomEvent('kvika:cart-updated', { detail: cart }));
      })
      .catch(function () {});
  }

  document.addEventListener('submit', function (e) {
    var form = e.target.closest && e.target.closest('form[data-kv-atc]');
    if (!form || !window.fetch) return;
    e.preventDefault();
    var btn = form.querySelector('[type="submit"]');
    if (btn) { btn.disabled = true; btn.classList.add('is-loading'); }

    var body, headers = { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' };
    var itemInputs = form.querySelectorAll('input[name$="[id]"][name^="items["]');
    if (itemInputs.length) {
      var items = [];
      itemInputs.forEach(function (inp) {
        var q = form.querySelector('input[name="' + inp.name.replace('[id]', '[quantity]') + '"]');
        items.push({ id: Number(inp.value), quantity: q ? Number(q.value) : 1 });
      });
      body = JSON.stringify({ items: items });
      headers['Content-Type'] = 'application/json';
    } else {
      body = new FormData(form);
    }

    fetch(root + 'cart/add.js', { method: 'POST', headers: headers, body: body })
      .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, d: d }; }); })
      .then(function (res) {
        if (!res.ok) throw new Error(res.d.description || res.d.message || 'Could not add to cart');
        if (document.querySelector('[data-kv-drawer]')) {
          // KVIKA Header is installed: open the cart drawer instead of a toast
          document.dispatchEvent(new CustomEvent('kvika:cart-added', { detail: res.d }));
        } else {
          toast(form.getAttribute('data-kv-success') || 'Added to your cart!', true);
        }
        refreshCount();
      })
      .catch(function (err) { toast(err.message || 'Something went wrong. Please try again.', false); })
      .finally(function () { if (btn) { btn.disabled = false; btn.classList.remove('is-loading'); } });
  });

  /* ---------------- Scroll cue: hover (desktop) or click/tap/Enter goes to the next section ---------------- */
  function nextSectionOf(el) {
    var wrap = el.closest('.shopify-section') || el.closest('section');
    var n = wrap ? wrap.nextElementSibling : null;
    while (n && (n.offsetHeight === 0 || getComputedStyle(n).display === 'none')) n = n.nextElementSibling;
    return n;
  }
  function scrollToNext(cue) {
    var target = nextSectionOf(cue);
    if (!target) return;
    var hd = parseInt(getComputedStyle(document.documentElement).getPropertyValue('--kvhd-h'), 10) || 0;
    var y = target.getBoundingClientRect().top + window.pageYOffset - hd;
    window.scrollTo({ top: y, behavior: reduce ? 'auto' : 'smooth' });
  }
  function initScrollCue(scope) {
    scope.querySelectorAll('[data-kv-scrollnext]').forEach(function (cue) {
      if (cue.__kvCue) return; cue.__kvCue = true;
      var timer = null, fired = false;
      cue.addEventListener('click', function (e) { e.preventDefault(); clearTimeout(timer); scrollToNext(cue); });
      if (finePointer.matches) {
        cue.addEventListener('mouseenter', function () {
          if (fired) return;
          timer = setTimeout(function () { fired = true; scrollToNext(cue); }, 350);
        });
        cue.addEventListener('mouseleave', function () { clearTimeout(timer); });
        // allow hovering again once the visitor is back at the top
        window.addEventListener('scroll', function () { if (window.pageYOffset < 50) fired = false; }, { passive: true });
      }
    });
  }

  /* ---------------- Video banner ---------------- */
  function initVideo(scope) {
    scope.querySelectorAll('[data-kv-video]').forEach(function (sec) {
      if (sec.__kvVid) return; sec.__kvVid = true;
      var vids = Array.prototype.slice.call(sec.querySelectorAll('video'));
      var playBtn = sec.querySelector('[data-kvvid-play]');
      var muteBtn = sec.querySelector('[data-kvvid-mute]');
      var userPaused = false, onScreen = true;
      function active() { return vids.filter(function (v) { return v.offsetParent !== null; }); }
      function sync() {
        var shouldPlay = !userPaused && onScreen && !document.hidden;
        active().forEach(function (v) { if (shouldPlay) { var p = v.play(); if (p && p.catch) p.catch(function () {}); } else v.pause(); });
        vids.forEach(function (v) { if (v.offsetParent === null) v.pause(); });
        sec.classList.toggle('is-paused', userPaused);
        if (playBtn) playBtn.setAttribute('aria-label', userPaused ? 'Play video' : 'Pause video');
      }
      vids.forEach(function (v) { v.muted = true; v.setAttribute('playsinline', ''); v.removeAttribute('controls'); });
      if (reduce) userPaused = true; // respect reduced motion: start paused
      if (playBtn) playBtn.addEventListener('click', function () { userPaused = !userPaused; sync(); });
      if (muteBtn) muteBtn.addEventListener('click', function () {
        var unmute = !sec.classList.contains('is-unmuted');
        vids.forEach(function (v) { v.muted = !unmute; });
        sec.classList.toggle('is-unmuted', unmute);
        muteBtn.setAttribute('aria-pressed', unmute ? 'true' : 'false');
        muteBtn.setAttribute('aria-label', unmute ? 'Turn sound off' : 'Turn sound on');
        if (unmute && userPaused) { userPaused = false; }
        sync();
      });
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (en) { onScreen = en[0].isIntersecting; sync(); }, { threshold: 0.15 }).observe(sec);
      }
      document.addEventListener('visibilitychange', sync);
      window.addEventListener('resize', sync, { passive: true });
      sync();
    });
  }

  /* ---------------- Boot + Shopify theme editor support ---------------- */
  function initAll(scope) {
    initReveal(scope);
    initParallax(scope);
    initPointer(scope);
    initVideo(scope);
    initScrollCue(scope);
    requestTick();
  }
  function boot() { initAll(document); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();

  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
  document.addEventListener('shopify:section:unload', function (e) {
    e.target.querySelectorAll('[data-kv-parallax]').forEach(function (r) {
      sections.delete(r); visible.delete(r); if (sectionIO) sectionIO.unobserve(r);
    });
  });
  reduceMQ.addEventListener && reduceMQ.addEventListener('change', function () { location.reload(); });
})();
